import { Footer } from "@/components/Layout/BaseLayouts/Footer/Footer";
import { Header } from "@/components/Layout/BaseLayouts/Header";
import { FCC } from "@/types";

/**
 * Minimal authenticated layout for mandatory profile steps (initial password,
 * personal data). Shows welcome branding and the new footer without portal nav.
 */
export const ProfileCompletionPageLayout: FCC = ({ children }) => (
  <div className="flex min-h-screen flex-col bg-background-secondary">
    <Header variant="welcomeLogo" />
    <main className="flex-grow">{children}</main>
    <Footer />
  </div>
);
